import { render, staticRenderFns } from "./AlertEditor.vue?vue&type=template&id=64eb37d2&scoped=true&"
import script from "./AlertEditor.vue?vue&type=script&lang=ts&"
export * from "./AlertEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AlertEditor.vue?vue&type=style&index=0&id=64eb37d2&lang=scss&scoped=true&"
import style1 from "./AlertEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb37d2",
  null
  
)

export default component.exports